/**
 * Capitalize the given string.
 *
 * @param {string} string The string.
 *
 * @returns {string} The capitalized string.
 */
export const capitalize = (string) => {
	const str = new String(string).toLowerCase();
	return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Potentially pluralize string given the count.
 *
 * @param {string}  string The string.
 * @param {integer} count  The determining factor.
 *
 * @returns {string} The possibly pluralized string.
 */
export const pluralize = (string, count) => {
	return `${string}${1 < count || 0 === count ? 's' : ''}`;
};

export default {
	capitalize,
	pluralize,
};
